import axiosInstance from "src/helpers/axiosInstance";
import { format } from 'date-fns'
import moment from "moment";
import dayjs from "dayjs";
import { encodeSpecialChars } from "src/views/pages/auth/Login/functions";




export const getDashboardWidgets = (props) => onResponse => {
    try {
        

        let base_url = 'dashboard/retrive-dashboard-reports?'

        if (props?.ist !== 'null' && props?.ist !== null) {
            base_url += `sd=${format(props?.ist[0], 'yyyy-M-dd')}&`
            base_url += `ed=${format(props?.ist[1], 'yyyy-M-dd')}&`
        }
        if (props?.month !== 'null' && props?.month !== null && props?.month !== undefined) {
            base_url += `m=${format(props?.month, 'M')}&`
            base_url += `y=${format(props?.month, 'y')}&`
        }


        if (props?.report_date !== 'null' && props?.report_date !== null) {
            base_url += `rsd=${format(props?.report_date[0], 'yyyy-M-dd')}&`
            base_url += `red=${format(props?.report_date[1], 'yyyy-M-dd')}&`
        }
     
        if (props?.format_type !== 'null' && props?.format_type !== null) {
            base_url += `format_type=${props?.format_type}&`
        }
        if (props?.reason !== 'null' && props?.reason !== null) {
            base_url += `reason=${props?.reason}&`
        }
         if (props?.search?.client_name !== 'null' && props?.search?.client_name !== null &&props?.search?.client_name !== undefined && Array.isArray(props?.search?.client_name) && props?.search?.client_name?.length>0)  {
            base_url += `client_id=${props?.search?.client_name?.join(',')}&`
        }

        axiosInstance.get(base_url)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {
        console.log(error)
    }

};
export const getDashboardWidgetsGraph = (props) => onResponse => {
    
    try {
        

        let base_url = 'dashboard/retrive-dashboard-daily-reports?'

        if (props?.ist !== 'null' && props?.ist !== null) {
            base_url += `sd=${format(props?.ist[0], 'yyyy-M-dd')}&`
            base_url += `ed=${format(props?.ist[1], 'yyyy-M-dd')}&`
        }
        if (props?.month !== 'null' && props?.month !== null && props?.month !== undefined) {
            base_url += `m=${format(props?.month, 'M')}&`
            base_url += `y=${format(props?.month, 'y')}&`
        }


        if (props?.report_date !== 'null' && props?.report_date !== null) {
            base_url += `rsd=${format(props?.report_date[0], 'yyyy-M-dd')}&`
            base_url += `red=${format(props?.report_date[1], 'yyyy-M-dd')}&`
        }

        if (props?.format_type !== 'null' && props?.format_type !== null) {
            base_url += `format_type=${props?.format_type}&`
        }
        if (props?.reason !== 'null' && props?.reason !== null) {
            base_url += `reason=${props?.reason}&`
        }
         if (props?.search?.client_name !== 'null' && props?.search?.client_name !== null &&props?.search?.client_name !== undefined && Array.isArray(props?.search?.client_name)&& props?.search?.client_name?.length>0) {
            base_url += `client_id=${props?.search?.client_name?.join(',')}&`
        }


        axiosInstance.get(base_url)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }

};
export const getDashboardWidgetsGraph1 = (props) => onResponse => {
    try {
       
        
        let base_url = 'dashboard/retrive-dashboard-monthly-reports?'

        if (props?.ist !== 'null' && props?.ist !== null) {
            base_url += `sd=${format(props?.ist[0], 'yyyy-M-dd')}&`
            base_url += `ed=${format(props?.ist[1], 'yyyy-M-dd')}&`
        }
        if (props?.month !== 'null' && props?.month !== null && props?.month !== undefined) {
            base_url += `m=${format(props?.month, 'M')}&`
            base_url += `y=${format(props?.month, 'y')}&`
        }


        if (props?.report_date !== 'null' && props?.report_date !== null) {
            base_url += `rsd=${format(props?.report_date[0], 'yyyy-M-dd')}&`
            base_url += `red=${format(props?.report_date[1], 'yyyy-M-dd')}&`
        }
        if (props?.format_type !== 'null' && props?.format_type !== null) {
            base_url += `format_type=${props?.format_type}&`
        }
        if (props?.reason !== 'null' && props?.reason !== null) {
            base_url += `reason=${props?.reason}&`
        }
        if (props?.search?.client_name !== 'null' && props?.search?.client_name !== null &&props?.search?.client_name !== undefined && Array.isArray(props?.search?.client_name)&& props?.search?.client_name?.length>0) {
            base_url += `client_id=${props?.search?.client_name?.join(',')}&`
        }

        axiosInstance.get(base_url)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }

};
export const keepAliveApi = () => onResponse => {
    try {
        let base_url = 'users/keep-alive'
        axiosInstance.get(base_url)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }

};
export const getSyncTimeApi = () => onResponse => {
    try {
        let base_url = 'dashboard/get-sync-time'
        axiosInstance.get(base_url)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }

};

export const getNonRevarcData = (props) => onResponse => {
    try {
        
        let base_url = 'file-monitor/job-monitor/stats?'
        if (props?.report_date !== 'null' && props?.search?.date !== null) {
            base_url += `rsd=${format(props?.search?.date[0], 'yyyy-M-dd')}&`
            base_url += `red=${format(props?.search?.date[1], 'yyyy-M-dd')}&`
        }
        if (props.search?.file_submitted_date && props.search?.file_submitted_date[0] && dayjs(props.search?.file_submitted_date && props.search?.file_submitted_date[0]).isValid()) {
            base_url += `ogt_start=${moment(props.search?.file_submitted_date[0]).format('YYYY-MM-DD')}&`
            base_url += `ogt_end=${moment(props.search?.file_submitted_date[1]).format('YYYY-MM-DD')}&`

        }
        //only for export>>>>>>>>>>>>>>>>>>>>>>
        if(props.export){
            base_url+= `export=csv&`
        }
        if(props.comment){
            base_url += `comment=${props?.comment}&`
        }
        if(props.headers){
            base_url += `header_names=${props?.headers}&`
        }
        base_url += `page=${props?.query.page}&limit=${props?.query.pageSize}&sort_key=${props?.search.sort_key}&sort_order=${props?.search.sort_order}&client_id=${props?.search.client_name}&facility_id=${props?.search.facility_name}&lockbox_file_name=${props?.search.file_name}&lockbox_number=${props?.search.lockbox_no}&exclude_completed=${props?.search.is_exclude}&file_group=${props?.search.is_file_level}&lockbox_file=${props?.search?.lockbox_file_name}`
        //only for export<<<<<<<<<<<<<<<<<<
        
        axiosInstance.get(base_url)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }

};
export const getExceptionReprtData = (props) => onResponse => {
    try {
        let base_url = `file-monitor/job-monitor/exception-report?lockbox_id=${props?.lockbox_id}&file_name=${props?.file_name}&file_wise_listing=${props?.file_wise_listing}`

        axiosInstance.get(base_url)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }

};
export const getUserRecoveryCode = (props) => onResponse => {
    try {
        let base_url = 'users/get-user-recovery-codes'

        axiosInstance.post(base_url,{user:props?.user})
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }

};
export const DashboardreportDownload = (format_type) => onResponse => {
    try {
        let base_url = 'dashboard/retrive-dashboard-reports?format_type=${props?.lockbox_id}'


        axiosInstance.get(base_url,{csv:format_type})
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {
        console.log(error)
    }

};